var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4383 5.47757C14.4383 6.13579 13.9384 6.66929 13.322 6.66929C12.7056 6.66929 12.2059 6.13579 12.2059 5.47757C12.2059 4.81936 12.7056 4.28564 13.322 4.28564C13.9384 4.28564 14.4383 4.81936 14.4383 5.47757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95093 4.28564H10.5317V6.66934H4.95093V4.28564Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5318 12.241V10.8407H13.3222C16.0847 10.8407 18.3449 8.42727 18.3449 5.47746C18.3449 2.52764 16.0847 0.114258 13.3222 0.114258L5.50906 0.114466C2.74651 0.114466 0.486328 2.52785 0.486328 5.47766C0.486328 8.42748 2.74651 10.8409 5.50906 10.8409H8.29946V12.2413C7.35077 12.5987 6.59731 13.4033 6.26252 14.4163H1.60239V16.8H6.26252L8.29946 16.7998V15.6081C8.29946 14.9525 8.80163 14.4163 9.41552 14.4163C10.0294 14.4163 10.5316 14.9525 10.5316 15.6081V16.7998H17.2286V14.4161L12.5686 14.4163C12.2336 13.4031 11.4803 12.5987 10.5314 12.241L10.5318 12.241ZM5.50906 8.45717C3.97428 8.45717 2.71865 7.11642 2.71865 5.47762C2.71865 3.83881 3.97428 2.49806 5.50906 2.49806H13.3222C14.857 2.49806 16.1126 3.83881 16.1126 5.47762C16.1126 7.11642 14.857 8.45717 13.3222 8.45717H5.50906Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataicon);
export default __webpack_public_path__ + "static/media/dataicon.864c95ca95849b8f4f6f5d82408b2bd5.svg";
export { ForwardRef as ReactComponent };